import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { grey } = colors;

const borders = {
  borderColor: grey[300],

  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs: pxToRem(1),
    sm: pxToRem(1),
    md: pxToRem(4),
    lg: pxToRem(8),
    xl: pxToRem(8),
    xxl: pxToRem(12),
    section: pxToRem(160),
  },
};

export default borders;
